<template>
    <div class="hidden sm:flex flex-row mx-auto bg-gradient-to-r from-racing-stars-dirty-yellow to-deep-blue rounded-md border border-racing-stars-yellow h-20 lg:h-40">
        <div class="w-[90%] flex flex-col mx-auto text-center pl-4">
            <!-- Progress Bar -->
            <div class="flex my-auto justify-between mx-auto w-full">
                <div v-for="i in 4" :key="i" class="flex flex-row w-full">
                    <div class="flex flex-col text-center">
                      <span class="border-4 border-racing-stars-yellow rounded-full bg-gray-800 lg:p-4 mx-auto w-10 h-10 lg:w-16 lg:h-16 text-xs lg:text-base">
                        <p class="my-2 lg:my-0 font-semibold" >{{ level.level - ((level.level - 1) % 5) + i - 1 }}</p>
                      </span>
                    </div>
                    <div class="h-2 bg-gray-500 rounded-md w-full mx-4 my-auto">
                        <div v-if="level.level === level.level - ((level.level - 1) % 5) + i - 1" class="h-2 bg-racing-stars-yellow rounded-md" :style="'width:'+((level.exp-level.prev) / (level.nextlevelxp-level.prev) * 100)+'%;'">  </div>
                        <div v-else-if="level.level > level.level - ((level.level - 1) % 5) + i - 1" class="h-2 bg-racing-stars-yellow rounded-md w-full" :class="[]"></div>
                    </div>
                </div>
            </div>
        </div>
        <span class="mr-4 my-auto text-center border-4 border-racing-stars-yellow rounded-full bg-gray-800 lg:p-7 mx-auto w-10 h-10 lg:w-24 lg:h-24 text-sm lg:text-2xl">
            <p class="my-[6px] lg:my-0 font-semibold ">
                {{ Math.ceil(level.level / 5) * 5 }}
            </p>
        </span>
    </div>

    <div class="flex sm:hidden justify-center mx-auto w-full bg-gradient-to-r from-racing-stars-dirty-yellow to-deep-blue rounded-md border border-racing-stars-yellow mt-4">
      <div class=" flex flex-col mx-3 my-6">
        <div class="flex mx-auto justify-center">
            <span class="text-white my-2 mx-auto px-2 font-semibold">Your Level</span>
        </div>
        <radial-progress-bar class="m-auto rounded-full bg-gray-800" :diameter="160" :completed-steps="level.exp - level.prev" :total-steps="level.nextlevelxp - level.prev" :strokeWidth="8" :innerStrokeWidth="8" :startColor="levelStartColor" :stopColor="levelStopColor" >
            <span class="text-3xl font-semibold">{{ level.level }}</span>
        </radial-progress-bar>
      </div>
    </div>

</template>

<script>

import { ChevronUpIcon } from '@heroicons/vue/outline'
import { GiftIcon } from '@heroicons/vue/outline'
import RadialProgressBar from 'vue-radial-progress'
import { ref, onMounted } from 'vue'

export default {

    components: {
        ChevronUpIcon,
        RadialProgressBar,
        GiftIcon
    },

    setup(props) {

        const level = ref(0)
        const getExp = () => {
            axios.get(route('api.exp.get'))
                .then(response => {
                    level.value = response.data
                })
        }

        onMounted(() => {
            getExp()
        })

        return {
            level
        }
    },


}

</script>
